import { render, staticRenderFns } from "./ResutlDetail.vue?vue&type=template&id=62cb3580&scoped=true"
import script from "./ResutlDetail.vue?vue&type=script&lang=js"
export * from "./ResutlDetail.vue?vue&type=script&lang=js"
import style0 from "./ResutlDetail.vue?vue&type=style&index=0&id=62cb3580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb3580",
  null
  
)

export default component.exports